import { render, staticRenderFns } from "./accept.vue?vue&type=template&id=3ebad756&scoped=true&"
import script from "./accept.vue?vue&type=script&lang=js&"
export * from "./accept.vue?vue&type=script&lang=js&"
import style0 from "./accept.vue?vue&type=style&index=0&id=3ebad756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebad756",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VSpacer})
